import { addForumtReaction, handleRetrieveForums } from "../../../../../redux/public-slices/forum.slice.js";
import { guestLoginFlow, refresher } from "../../../../../redux/guest-slices/other.slice.js";
import { checkUserType, debounce, FILE_PATH_URI } from "../../../../../utils/helper.js";
import { TruncatedDescription } from "../../../../../components/common/TruncateText.jsx";
import ShareDialog from "../../../../../components/common/dialogs/ShareDialog.jsx";
import TablePagination from "../../../../../components/common/TablePagination.jsx";
import { Fragment, lazy, Suspense, useEffect, useRef, useState } from "react";
import SectionSkeleton from "../../../../../components/ui/SectionSkeleton.jsx";
import { Link as NavLink, useNavigate, useParams } from "react-router-dom";
import SkeletonImage from "../../../../../components/ui/SkeletonImage.jsx";
import { useDispatch, useSelector } from "react-redux";
import Images from "../../../Home/temp-data/Images.js";
import Icons from "../../../../../assets/js/Icons.js";
import moment from "moment";
import Aside from "./Aside.jsx";

import {
  Alert, Avatar, Box, Button, Container, Divider, Grid2 as Grid,
  Icon, Link, Paper, Skeleton, Stack, TextField, Typography,
} from "@mui/material";

const TopBannerA = lazy(() => import("../../../../../components/common/TopBannerA.jsx"));

function ForumCategory() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchRef = useRef(null);

  const { categoryId } = useParams();
  const [data, setData] = useState({});
  const { refresh, loadings } = useSelector((state) => state.otherSlice);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedForumData, setSelectedForumData] = useState(null);

  // Handle get all blogs
  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      handleRetrieveForums({
        currentPage: filters?.currentPage || null,
        search: searchRef?.current?.value || null,

        categoryId: categoryId || null,
      })
    ).unwrap();
    setData(response);
  };
  // Handle guest login
  const handleLogin = () => {
    dispatch(guestLoginFlow());
  };

  // Handle comment reaction
  const handleReaction = async (id, type) => {
    if (checkUserType()) {
      await dispatch(
        addForumtReaction({
          id,
          formData: { type },
        })
      );
      dispatch(refresher());
    } else {
      handleLogin();
    }
  };
  const handleShareClick = (data) => {
    if (checkUserType()) {
      setSelectedForumData(data);
      setShareDialogOpen(true);
    } else {
      handleLogin();
    }
  };

  // Handle share dialog close
  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
    setSelectedForumData(null);
  };
  const handleCommentClick = (id) => {
    if (checkUserType()) {
      navigate(`/forum/${id}`);
    } else {
      handleLogin();
    }
  };
  const handleReport = (id) => {
    if (checkUserType()) {
      navigate(`/forum/${id}`);
    } else {
      handleLogin();
    }
  };

  const handleSearch = debounce(() => {
    handleRetrieveAll();
  }, 1000);
  useEffect(() => {
    handleRetrieveAll();

    // eslint-disable-next-line
  }, [categoryId, refresh]);

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          currentPage={data?.category?.name || "Forum Category"}
          bannerImg={data?.category?.image || Images?.forumImg4}
          heading={data?.category?.name || "Forum Category"}
          menus={[{ name: "Community Forums", path: "/forums" }]}
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, laptop: 8 }}>
              <Box
                sx={{
                  gap: 3,
                  ml: "auto",
                  display: "flex",
                  maxWidth: "1000px",
                  flexDirection: "column",
                  height: "fit-content",
                  position: "sticky",
                  top: 20,
                  overflowY: "auto",
                }}
              >
                <Grid size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
                  <TextField
                    size="small"
                    type="search"
                    inputRef={searchRef}
                    sx={{ width: "100%" }}
                    onChange={handleSearch}
                    placeholder="Search Forums"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <Icon
                            sx={{ fontSize: "18px", mr: 1, color: "#858585" }}
                          >
                            <Icons.Search />
                          </Icon>
                        ),
                      },
                    }}
                  />
                </Grid>
                {loadings?.retrieveAll ? (
                  new Array(4).fill().map((_, i) => (
                    <Skeleton
                      key={i}
                      sx={{
                        width: "100%",
                        transform: "none",
                        aspectRatio: "1/0.5",
                      }}
                    />
                  ))
                ) : data?.records?.length === 0 ? (
                  <Alert
                    sx={{
                      fontSize: "20px",
                      fontWeight: "500",
                      alignItems: "center",
                      fontFamily: "Poppins",
                      ".MuiAlert-message": { p: "0" },
                      ".MuiAlert-icon": { fontSize: "28px" },
                    }}
                    color="error"
                    severity="error"
                  >
                    No Records Found!
                  </Alert>
                ) : (
                  data?.records?.map((element, i) => (
                    <Paper
                      key={i}
                      sx={{
                        p: 2,
                        gap: 1,
                        display: "flex",
                        borderRadius: "6px",
                        border: "1px solid",
                        borderColor: "divider",
                        flexDirection: "column",
                        transition: "all 450ms ease",
                        boxShadow: "0 0 10px 0 #0000000a",
                        ":hover": {
                          boxShadow: "0 0 10px 0 #00000021",
                        },
                      }}
                    >
                      <Stack
                        spacing={1}
                        direction="row"
                        sx={{ alignItems: "center" }}
                        divider={<Divider flexItem orientation="vertical" />}
                      >
                        <Avatar
                          sx={{ width: 35, height: 35 }}
                          src={element?.author?.image}
                        />

                        <Typography
                          fontWeight="600"
                          color="#272b41"
                          textTransform="capitalize"
                        >
                          {" "}
                          {element?.author?.fullName}
                        </Typography>

                        <Typography
                          fontWeight=""
                          color="#272b41"
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {" "}
                          {moment(element?.createdAt).format("MMM DD YYYY")}
                        </Typography>
                        <Typography
                          color="#272b41"
                          fontSize={{ xs: 14, md: 16 }}
                        >
                          {element?.comments || 0} Comments
                        </Typography>
                      </Stack>

                      <Link
                        sx={{
                          mt: 2,
                          width: "100%",
                          overflow: "hidden",
                          WebkitLineClamp: 1,
                          color: "other.color1",
                          display: "-webkit-box",
                          // WebkitBoxOrient: "vertical",
                          transition: "all 350ms ease",
                          ":hover": {
                            color: "primary.main",
                          },
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                        fontSize={22}
                        fontWeight="600"
                        underline="hover"
                        component={NavLink}
                        to={`/forum/${element?._id}`}
                      >
                        {element?.title}
                      </Link>
                      <Box
                        sx={{
                          width: "100%",
                          lineHeight: "1.3",
                          WebkitLineClamp: 2,
                          color: "other.color1",
                          display: "-webkit-box",
                          // WebkitBoxOrient: "vertical",
                          transition: "all 350ms ease",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        <TruncatedDescription
                          text={element?.description}
                          maxLength={50}
                        />
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      <Box
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          borderRadius: "6px",
                          aspectRatio: "1/0.6",
                        }}
                      >
                        <SkeletonImage
                          src={
                            element?.banner?.path
                              ? FILE_PATH_URI + element?.banner?.path
                              : Images.forumImg3
                          }
                        />
                      </Box>

                      <Stack
                        my={2}
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        flexWrap={"wrap"}
                        sx={{
                          "& > :not(style) ~ :not(style)": {
                            marginLeft: { xs: "5px", sm: "5px" },
                          },
                        }}
                      >
                        <Button
                          size="small"
                          disableRipple
                          color="secondary"
                          sx={{
                            fontSize: "15px",
                            ".MuiButton-icon": { mr: "5px" },
                          }}
                          startIcon={<Icons.ThumbsUpSolid />}
                          onClick={() => {
                            handleReaction(element?._id, "like");
                          }}
                        >
                          Like ({element?.likes || 0})
                        </Button>
                        <Button
                          size="small"
                          disableRipple
                          color="secondary"
                          sx={{
                            fontSize: "15px",
                            ".MuiButton-icon": { mr: "5px" },
                          }}
                          startIcon={<Icons.ThumbsDownSolid />}
                          onClick={() => {
                            handleReaction(element?._id, "dislike");
                          }}
                        >
                          Unlike ({element?.dislikes})
                        </Button>
                        <Button
                          size="small"
                          disableRipple
                          color="secondary"
                          sx={{
                            fontSize: "15px",
                            ".MuiButton-icon": { mr: "5px" },
                          }}
                          startIcon={<Icons.ShareSolid />}
                          onClick={() => handleShareClick(element)}
                        >
                          Share
                        </Button>
                        <Button
                          size="small"
                          disableRipple
                          color="secondary"
                          sx={{
                            fontSize: "15px",
                            ".MuiButton-icon": { mr: "5px" },
                          }}
                          startIcon={<Icons.Comment1 />}
                          component={NavLink}
                          // to={`/forum/${element?._id}`}
                          onClick={() => handleCommentClick(element?._id)}
                        >
                          Comment ({element?.comments || 0})
                        </Button>
                        <Button
                          size="small"
                          disableRipple
                          color="secondary"
                          sx={{
                            fontSize: "15px",
                            ".MuiButton-icon": { mr: "5px" },
                          }}
                          startIcon={<Icons.ComplaintSolid />}
                          onClick={() => {
                            handleReport(element?._id);
                          }}
                        >
                          Report
                        </Button>
                      </Stack>
                    </Paper>
                  ))
                )}
                <TablePagination
                  pagination={data?.pagination}
                  length={data?.records?.length}
                  loading={loadings?.retrieveAll}
                  cb={handleRetrieveAll}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, laptop: 4 }}>
              <Box
                sx={{
                  py: 8,
                  px: 3,
                  gap: 10,
                  // height: "100%",
                  display: "flex",
                  borderRadius: 2,
                  bgcolor: "#EBF5F5",
                  flexDirection: "column",
                  boxShadow: "0 0 10px 0 #0000000a",
                }}
              >
                <Aside categoryIcon={data.records} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <ShareDialog
        open={shareDialogOpen}
        onClose={handleShareDialogClose}
        forumData={selectedForumData}
        id={data?._id}
      />
    </Fragment>
  );
}

export default ForumCategory;
